import React,{useState, useEffect} from 'react'
import { Button, Card, Descriptions } from "antd";
import { useSelector } from 'react-redux';
import { Country, State } from 'country-state-city';
import { SUPPLIER_DETAILS_CONSTANTS } from '../../constants/Constants';
import "./SupplierProfile.css";

function SupplierProfile({setStep,setEditing,handleEdit}) {
    const {
        FirstName,
        LastName,
        userId,
        emailId,
        phoneNumber,
        userType,
        designation,
        country,
        companyName,
        addressLine1,
        addressLine2,
        supplierType,
        state,
        zipcode,additionalDetails,isUser
      } = useSelector((state) => state.signup);
      const [isMobile, setIsMobile] = useState(false);
      useEffect(() => {
        const checkMobile = () => {
          setIsMobile(window.innerWidth <= 768);
        };
    
        checkMobile();
        window.addEventListener("resize", checkMobile);
    
        return () => {
          window.removeEventListener("resize", checkMobile);
        };
      }, []);
      const ROLE=sessionStorage.getItem("Role")
      const stateName=State.getStateByCodeAndCountry(state,country)?.name;
      const countryName=Country.getCountryByCode(country)?.name;


      
    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100 supplier-profile-table">
      <Card className="w-full  rounded-xl">
  <h2 className="text-2xl font-semibold text-center mb-4">Supplier Details</h2>
  
  <Descriptions bordered column={1} layout={isMobile ? "vertical": "horizontal"}>
    <Descriptions.Item label="Company Name">{companyName}</Descriptions.Item>
    <Descriptions.Item label="Address Line 1">{addressLine1}</Descriptions.Item>
    <Descriptions.Item label="Address Line 2">{addressLine2 ? addressLine2 : "N/A"}</Descriptions.Item>
    <Descriptions.Item label="Supplier Type">{supplierType}</Descriptions.Item>
    <Descriptions.Item label="Country">{countryName}</Descriptions.Item>
    <Descriptions.Item label="State">{stateName}</Descriptions.Item>
    <Descriptions.Item label="Zip Code">{zipcode}</Descriptions.Item>
    </Descriptions>
    <div  className='mt-5'>
    <Button disabled={isUser || ROLE=="Supplier User"} onClick={()=>{
      setStep(1);
      setEditing(true)
      }}>Edit</Button>
  </div>
    <div className="mt-6">

    <h3 className="text-xl font-semibold mb-2">Contact Details</h3>
    <Descriptions bordered column={1} layout={isMobile ? "vertical": "horizontal"}>
    <Descriptions.Item label="First Name">{FirstName}</Descriptions.Item>
    <Descriptions.Item label="Last Name">{LastName}</Descriptions.Item>
    <Descriptions.Item label="User ID">{userId}</Descriptions.Item>
    <Descriptions.Item label="Email ID">{emailId}</Descriptions.Item>
    <Descriptions.Item label="Phone Number">{phoneNumber}</Descriptions.Item>
    <Descriptions.Item label="User Type">{userType}</Descriptions.Item>
    <Descriptions.Item label="Designation">{designation}</Descriptions.Item>
  </Descriptions>
  <div  className='mt-5'>
  <Button onClick={()=>{
      handleEdit(SUPPLIER_DETAILS_CONSTANTS.CONTACT_TYPE, 0)
      }}>Edit</Button>
  </div>
</div>
  {/* Additional Details Section */}
  <div className="mt-6">
  <h3 className="text-xl font-semibold mb-2">Additional Details</h3>
  
  <Descriptions bordered column={1} layout={isMobile ? "vertical": "horizontal"}>
    {additionalDetails && additionalDetails.length > 0 ? (
      additionalDetails.map((detail, index) => (
        <Descriptions.Item key={index} label={`Detail ${index + 1}`}>
          <strong>ID:</strong> {detail.supplierId} <br />
          <strong>Country:</strong> {detail.countryCode}
        </Descriptions.Item>
      ))
    ) : (
      <Descriptions.Item label="No additional details available." />
    )}
  </Descriptions>
  <div className='mt-5'>
  <Button disabled={isUser || ROLE=="Supplier User"} onClick={()=>{
      setStep(3);
      setEditing(true)
      }}>Edit</Button>
  </div>
</div>

</Card>


        </div>
      );
    };

export default SupplierProfile